import { Box, Container, Grid, Typography } from "@mui/material";

const OurStoryPage = () => {
  return (
    <Box sx={{ pt: "5%" }}>
      <Container maxWidth="xl">
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "72px",
            lineHeight: "82px",
            color: "#6E8C20",
          }}
        >
          Our{" "}
          <Typography
            component="span"
            sx={{
              fontWeight: 700,
              fontSize: "72px",
              lineHeight: "82px",
              color: "#323232",
            }}
          >
            Story
          </Typography>
        </Typography>

        <Typography
          sx={{
            color: "#323232",
            fontWeight: 500,
            fontSize: "17px",
            lineHeight: "30px",
            textAlign: "justify",
            my: "20px",
          }}
        >
          While the farmers’ challenges are numerous, and we may not have all
          the answers to the puzzle, but creating an alternative to the shortage
          of machinery has been the most important piece of our puzzle and this
          is our humble attempt to resolve the issue…
        </Typography>

        <Grid container spacing={4} wrap="wrap-reverse">
          <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
            <Typography
              sx={{
                color: "#6E8C20",
                fontWeight: 600,
                fontSize: "30px",
                lineHeight: "45px",
                mb: "20px",
              }}
            >
              How it all began?
            </Typography>
            <Typography
              sx={{
                color: "#323232",
                fontWeight: 500,
                fontSize: "17px",
                lineHeight: "30px",
                textAlign: "justify",
              }}
            >
              In 2021, Santosh found himself in a challenging situation. The
              shortage of farm equipment and skyrocketing costs due to the
              effects of Covid-19 on agriculture were making it difficult for
              him to start his cultivation in his farm in Barrington Hills, IL.
              Despite his efforts to find equipment in neighboring states like
              Wisconsin, Indiana, Iowa and Kansas, he was met with little
              success.
            </Typography>
            <Typography
              sx={{
                color: "#323232",
                fontWeight: 500,
                fontSize: "17px",
                lineHeight: "30px",
                textAlign: "justify",
                mt: "15px",
              }}
            >
              Faced with dilemma, Santosh considered alternative solutions. The
              prospect of buying new tractors and implements was a significant
              financial commitment. So, he began to contemplate the possibility
              of renting them on an interim basis. However, even this proved to
              be a daunting task. After combing the market, his disappointment
              grew when he realized that there was no such practice or
              convenience available.
            </Typography>
          </Grid>
          <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
            <Box
              component="img"
              src="/assets/img/our-story.png"
              sx={{
                height: "463px",
                width: "100%",
                float: "right",
                backgroundRepeat: "no-repeat",
              }}
            />
          </Grid>
        </Grid>
      </Container>
      <Box sx={{ background: "#FBFFF3", mt: "20px" }}>
        <Container maxWidth="xl">
          <Box sx={{ py: "30px" }}>
            <Typography
              sx={{
                color: "#6E8C20",
                fontWeight: 600,
                fontSize: "30px",
                lineHeight: "45px",
                mb: "20px",
              }}
            >
              When the going gets tough, the tough gets going
            </Typography>
            <Typography
              sx={{
                color: "#323232",
                fontWeight: 500,
                fontSize: "17px",
                lineHeight: "30px",
                textAlign: "justify",
                mt: "15px",
              }}
            >
              Despite the financial strain, he invested in an older tractor and
              gradually gathered more equipment. Over time, he realized that a
              significant portion of his equipment remained idle for extended
              periods, especially during the harsh Chicago winters when farming
              was limited.
            </Typography>

            <Typography
              sx={{
                color: "#6E8C20",
                fontWeight: 600,
                fontSize: "30px",
                lineHeight: "45px",
                mb: "20px",
                mt: "30px",
              }}
            >
              Escape the ordinary, Explore the extraordinary!!
            </Typography>
            <Typography
              sx={{
                color: "#323232",
                fontWeight: 500,
                fontSize: "17px",
                lineHeight: "30px",
                textAlign: "justify",
              }}
            >
              It was clear to Santosh that he needed to think outside the box
              and consider unconventional methods to explore creative solutions.
               He harnessed technology with agriculture to enhance the
              opportunities for farmers to acquire agricultural equipment. Being
              a technology pioneer, and a P2P marketplace user, Santosh
              developed this unique product, Haystackers. It is his small yet
              mighty effort to improve efficiency and sustainability in
              agricultural practices with a peer-to-peer marketplace. It is his
              dream to provide an avenue for farmers to access and share the
              idle agricultural equipment, foster collaboration among
              neighboring farmers, ultimately benefitting the entire farming
              ecosystem. At its core, Haystackers aims to contribute to
              environmental sustainability by reducing the carbon footprint
              associated with agriculture.
            </Typography>
          </Box>
        </Container>
      </Box>
      <Box>
        <Container maxWidth="xl">
          <Box sx={{ py: "50px" }}>
            <img
              src="/assets/img/Logo.png"
              alt=""
              width="286px"
              height="88px"
            />

            <Typography
              sx={{
                color: "#323232",
                fontWeight: 500,
                fontSize: "17px",
                lineHeight: "30px",
                textAlign: "justify",
                mt: "30px",
              }}
            >
              As the pioneer of this groundbreaking initiative, Haystackers
              stands as the inaugural peer to peer marketplace designed
              exclusively for farmers to rent out their tractors and farm
              equipment to enable needy farmers to access necessary machinery
              without incurring the upfront costs associated with buying. This
              approach is particularly advantageous for small-scale farmers or
              those operating on a tight budget, offering a more cost-effective
              option to meet their agricultural needs. By bridging this gap,
              Haystackers not only promotes financial accessibility but also
              encourages a spirit of cooperation and resource- sharing within
              the farming community.
            </Typography>

            <Grid container spacing={4}>
              <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
                {" "}
                <Typography
                  sx={{
                    color: "#323232",
                    fontWeight: 500,
                    fontSize: "17px",
                    lineHeight: "30px",
                    textAlign: "justify",
                    mt: "30px",
                  }}
                >
                  From increased growth to maximizing crop yield with affordable
                  costs, the advantages are apparent with Haystackers. This new
                  agriculture revolution can precisely measure year-round,
                  increasing food production with reliable harvests. <br />
                  Farming is constantly evolving. So, everything from land
                  preparation, irrigation, fertilizing and harvesting, our
                  growing collection of agricultural equipment rentals will meet
                  your changing needs. Through a collateral-focused approach,
                  Haystackers offers farmers a spectrum of equipment that can
                  adapt with changing needs and lay the foundation of long-term
                  success for farmers, ranchers, and landowners nationwide.
                </Typography>
                <Typography
                  sx={{
                    color: "#323232",
                    fontWeight: 700,
                    fontSize: "17px",
                    lineHeight: "30px",
                    textAlign: "justify",
                    mt: "30px",
                  }}
                >
                  Vision of Haystackers is to add productivity to crop
                  production world wide by leveraging peer to peer sharing of
                  essential farming equipment among farmers.
                </Typography>
              </Grid>
              <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
                <Box
                  component="img"
                  src="/assets/img/our-story-2.png"
                  sx={{
                    height: "432px",
                    width: "100%",
                    float: "right",
                    backgroundRepeat: "no-repeat",
                  }}
                  mt="30px"
                />
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
      <Box sx={{ background: "#FBFFF3", mt: "20px", minHeight: "256px" }}>
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              minHeight: "256px",
              my: "20px",
            }}
          >
            <Typography
              sx={{
                color: "#6E8C20",
                fontWeight: 600,
                fontSize: "30px",
                lineHeight: "45px",
                mb: "20px",
                textAlign: "center",
              }}
            >
              Grow together, thrive together
            </Typography>
            <Typography
              sx={{
                color: "#323232",
                fontWeight: 500,
                fontSize: "17px",
                lineHeight: "30px",
                textAlign: "center",
                mt: "15px",
              }}
            >
              United by a shared goal of making agriculture more accessible and
              sustainable, Haystackers fosters a tight-knit community of
              farmers. This sense of camaraderie is at the heart of our
              platform.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default OurStoryPage;
